import { supabase } from '@/lib/supabase/client';

export type ReadingProgress = {
  user_id: string;
  last_surah_id: number;
  last_ayah_number: number;
  updated_at: string;
};

export async function getReadingProgress(): Promise<ReadingProgress | null> {
  const { data, error } = await supabase
    .from('reading_progress')
    .select('*')
    .maybeSingle();
  if (error) throw error;
  return (data as ReadingProgress | null) ?? null;
}

export async function upsertReadingProgress(input: {
  user_id: string;
  last_surah_id: number;
  last_ayah_number: number;
}): Promise<void> {
  const { error } = await supabase
    .from('reading_progress')
    .upsert(
      {
        user_id: input.user_id,
        last_surah_id: input.last_surah_id,
        last_ayah_number: input.last_ayah_number,
      },
      { onConflict: 'user_id' },
    );
  if (error) throw error;
}
